import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import Nto3 from '@hooks/web/tab1/nto3.tsx';
import Final from '@hooks/web/tab1/final.tsx';
interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
interface Props {
  iArea: number,
}
const { useEffect, useState, useContext } = React;
const Tab1: React.FC<Props> = props => {
  const { iStage, tabToastOpen } = useContext(StageDefault);
  const [IStage] = useState<number>(iStage > 4 ? 4 : iStage);
  const [current, Current] = useState<number>(iStage > 4 ? 4 : iStage);
  const [tabs] = useState<TabsType[]>([
    {
      current: 0,
      title: '预选N进40',
      time: '12.2',
      tips: '所有没获得新势力资格赛的主播进行比拼，排名前40名主播通过预选',
    },
    {
      current: 1,
      title: 'N进18',
      time: '12.3-12.4',
      tips: '通过预选赛的主播和超能新星赛中获得资格的主播进行比拼，排名前18名的主播晋级',
    },
    {
      current: 2,
      title: '18进8',
      time: '12.5-12.6',
      tips: '每天淘汰后5名主播，决出8强主播晋级决赛',
    },
    {
      current: 3,
      title: '决赛',
      time: '12.7',
      tips: '最后之战，决出年度游戏新势力冠亚季军',
    },
  ])
  return (
    <div
      className='web-tab1'
    >
      <div className='tab1_nav'>
        {
          [tabs].map((item: any, index: number) => (
            <ul key={index}>
              {
                item.map((navItem: TabsType, Index: number) => (
                  <li
                    key={Index}
                    className={
                      current === (Index + 1) ? 'on' : ''
                    }
                    onClick={
                      () => {
                        if (Index + 1 > IStage) {
                          tabToastOpen('该赛程暂未开始，敬请期待');
                          return;
                        };
                        Current(Index + 1);
                      }
                    }
                  >
                    <h2>{navItem.title}</h2>
                    <i></i>
                    <p>{navItem.time}</p>
                    <div className='tab-tips'>{navItem.tips}</div>
                  </li>
                ))
              }
            </ul>
          ))
        }
      </div>
      {
        // eslint-disable-next-line array-callback-return
        [Nto3, Nto3, Nto3, Final].map((item: any, index: number) => {
          if (index === (current - 1)) {
            const COMP = item;
            return <COMP key={index} iStage={current} iArea={props.iArea} />
          }
        })
      }
    </div>
  )
}

export default Tab1;